export default __webpack_public_path__ + "static/avatar-kayi-common-3-cover-a1da4e502cdea777a364aa6e83f1a459.png";